// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"976342de","862":"ae70e7e7","987":"9a771b6d"}[chunkId] + ".chunk.css";
};